import React, { Component } from 'react';
import { injectGlobal } from 'react-emotion';
import { ThemeProvider } from 'emotion-theming';
import { lowTheme } from 'optilit-themes';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ShopConatiner } from './containers/status';
import createStore from './store';
import LoginView from './components/views/login';

import global from './util/globalstyle';
injectGlobal(global);

const store = createStore();
// ---------------------
// APP.
// ---------------------
class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Provider store={store}>
          <ThemeProvider theme={lowTheme}>
            <Router>
              <Switch>
                <Route exact path="/login" component={LoginView} />
                <Route
                  path="/shop"
                  render={() => {
                    return <Redirect to="/" />;
                  }}
                />
                <ShopConatiner />
              </Switch>
            </Router>
          </ThemeProvider>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js